export const COMMENT_NOTIFICATIONS_MODEL = "comment-notifications";

const commentNotificationsModel = {
  created: false
};

export default commentNotificationsModel;
